<template>
  <div class="pBox" v-loading="loading">
    <div class="feedbackSurvey">
      <div v-if="false">
        <div class="required">
          <i class="el-icon-right" />
          必填
        </div>
        <p class="paragraph">
          为了更好地为您提供服务，三星商城将收集并分析您的问卷调查。有关详情，请参阅隐私声明。
        </p>
        <p class="paragraph">
          请仅在您认真阅读并接受《隐私声明》中规定的条款后再继续填写问卷调查.
        </p>
        <p class="paragraph">
          <a
            href="https://www.samsungeshop.com.cn/appPolicy?code=1"
            class="layout_rte"
            target="_blank"
            rel="nofollow noopener noreferrer"
          >隐私政策</a>
        </p>
        <!-- <p class="paragraph">
          我们仅在征得您的同意后向第三方国家或国际组织传输您的个人信息、敏感个人信息或生物识别信息.
        </p>
        <p class="paragraph">
          <a
            href="https://drive.google.com/file/d/1wysNIXaESY9-Lg_9Fhttn3hYmTmnYwrj/view?usp=sharing"
            class="layout_rte"
            target="_blank"
            rel="nofollow noopener noreferrer"
            >收集和使用个人信息授权同意书</a
          >
        </p> -->
        <div class="isAgree">
          <el-checkbox v-model="isAgree" label="我已阅读并同意隐私政策" border />
        </div>
        <div class="agreeBtn">
          <el-button
            type="primary"
            @click="consentToTheSurvey"
          >同意并开始调查</el-button>
        </div>
        <!-- <div class="support">
          <p>
            <span>Powered by </span>
            <span>Medallia</span>
          </p>
          <p>
            <a
              href="http://surveysupport.medallia.com/s/"
              target="_blank"
              rel="external"
              >调查支持</a
            >
            <a
              href="https://www.medallia.com/privacy-policy/"
              target="_blank"
              rel="external"
              >隐私政策</a
            >
            <a
              href="http://survey.medallia.com/static/cookie-policy/index.html"
              target="_blank"
              >Cookie政策</a
            >
          </p>
        </div> -->
      </div>
      <div v-if="isMainland && page === 1" class="statement">*您填写的以下信息仅用于对本次三星维修服务的满意度调查，以便我们进一步改善服务。我们充分认识到个人信息对您的重要性，将严格按照《个人信息保护法》等法律法规处理您的个人信息，并采取相应的安全保护措施，尽最大努力确保您个人信息的安全性和可靠性。</div>
      <template v-if="answerState && questionnaireData.length">
        <div v-for="(qaItem, qaIndex) in questionnaireData" :key="qaIndex+'aa'">
          <!-- <template v-if="true"> -->
          <template v-if="showElementsByPage(qaIndex, page, pageSize)">
            <div v-if="qaItem.quesContentTyp === '2'">
              <div class="paragraph">
                <div class="required">
                  <i class="el-icon-right" />
                  必填
                </div>
                <!-- {{ qaItem.quesNm }} -->
                <div v-html="qaItem.quesNm"></div>
              </div>
              <div class="rate1">
                <div v-if="isHK || isIIHK" class="hint">
                  <div class="hintL">完全不可能<br>Not at all likely</div>
                  <div class="hintR">極有可能<br>Extremely Likely</div>
                </div>
                <div v-else class="hint">
                  <div class="hintL">完全不推荐</div>
                  <div class="hintR">非常愿意推荐</div>
                </div>
                <!-- <el-rate v-model="form.val1" :max="10" show-score @change="radioChange" /> -->
                <div class="rateComponents">
                  <div v-for="(item,index) in qaItem.answ" :key="index" class="rateItem" @click="checkedRate(item,qaIndex)">
                    <div class="rateNum" :class="qaItem.value===item.answId?'select':''">{{ item.answVal }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="qaItem.quesContentTyp === '7'">
              <div class="paragraph">
                <div class="required">
                  <i class="el-icon-right" />
                  必填
                </div>
                <!-- {{ qaItem.quesNm }} -->
                <div v-html="qaItem.quesNm"></div>
              </div>
              <div class="rate1">
                <div class="hint">
                  <div class="hintL">非常不满意<br>Completely Dissatisfied</div>
                  <div class="hintR">非常满意<br>Completely Satisfied</div>
                </div>
                <!-- <el-rate v-model="form.val1" :max="10" show-score @change="radioChange" /> -->
                <div class="rateComponents">
                  <div v-for="(item,index) in qaItem.answ" :key="index" class="rateItem" @click="checkedRate(item,qaIndex)">
                    <div class="rateNum" :class="qaItem.value===item.answId?'select':''">{{ item.answVal }}</div>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- <div v-if="qaItem.quesContentTyp === '1'">
              <div>
                <div class="paragraph">
                  <div class="required">
                    <i class="el-icon-right" />
                    必填
                  </div>
                  {{ qaItem.quesNm }}
                </div>
                <div class="group_group">
                  <div class="group_optionContainer" v-for="(item) in qaItem.answ" :key="item.id+'bb'">
                    <el-radio v-model="qaItem.value" :label="item.answId">{{ item.answVal }}</el-radio>
                  </div>
                </div>
              </div>
            </div> -->
            <div v-if="qaItem.quesContentTyp === '1'">
              <div v-for="(item, index) in qaItem.list" :key="item.quesId">
                <div class="paragraph">
                  <div class="required">
                    <i class="el-icon-right" />
                    必填
                  </div>
                  <!-- {{ item.quesNm }} -->
                  <div v-html="item.quesNm"></div>
                </div>
                <div class="group_group">
                  <div class="group_optionContainer" v-for="(itemC) in item.answ" :key="itemC.answId+'bb'">
                    <el-radio v-model="item.value" :label="itemC.answId" @change="radioChange($event,qaIndex,itemC,index)">{{ itemC.answVal }}</el-radio>
                  </div>
                </div>
              </div>
              <!-- <template v-if="qaItem.list && qaItem.list.length">
              <div v-for="(item, index) in qaItem.list" :key="item.answId">
                <div class="group_group mt20">
                  <div v-for="(itemC) in item.option" :key="itemC.answId" class="group_optionContainer">
                    <el-radio v-model="item.value" :label="itemC.answId" @change="radioChange($event,qaIndex,itemC,index)">{{ itemC.answVal }}</el-radio>
                  </div>
                </div>
              </div>
              </template>
              <template v-else>
                <div class="group_group">
                  <div class="group_optionContainer" v-for="(item) in qaItem.answ" :key="item.id+'bb'">
                    <el-radio v-model="qaItem.value" :label="item.answId">{{ item.answVal }}</el-radio>
                  </div>
                </div>
              </template> -->
              <!-- <div v-if="qaItem.answer.secondaryOption && qaItem.answer.secondaryOption.option.some((item) => {return item.parent === qaItem.answer.value})">
                <div class="group_group mt20">
                  <template v-for="(item) in qaItem.answer.secondaryOption.option" >
                    <div v-if="item.parent === qaItem.answer.value" class="group_optionContainer" :key="item.id+'cc'">
                      <el-radio v-model="qaItem.answer.secondaryOption.value" :label="item.id" @change="radioChange($event,qaIndex,2)">{{ item.content }}</el-radio>
                    </div>
                  </template>
                </div>
              </div>
              <div v-if="qaItem.answer.threeOption && qaItem.answer.secondaryOption.option.some((item) => {return item.parent === qaItem.answer.value}) && qaItem.answer.threeOption.option.some((item) => {return item.parent === qaItem.answer.secondaryOption.value})">
                <div class="group_group mt20">
                  <template v-for="(item) in qaItem.answer.threeOption.option" >
                    <div v-if="item.parent === qaItem.answer.secondaryOption.value" class="group_optionContainer" :key="item.id+'dd'">
                      <el-radio v-model="qaItem.answer.threeOption.value" :label="item.id" @change="radioChange($event,qaIndex,3)">{{ item.content }}</el-radio>
                    </div>
                  </template>
                </div>
              </div> -->
            </div>
            <div v-if="qaItem.quesContentTyp === '3'">
              <div class="paragraph">
                <!-- {{ qaItem.quesNm }} -->
                <div v-html="qaItem.quesNm"></div>
              </div>
              <el-input
                v-model="qaItem.value"
                @input="e => qaItem.value = removeHTMLTag(e)"
                style="width: 100%; margin-bottom: 20px"
                type="textarea"
                :rows="6"
                placeholder=""
                :maxlength="200"
                show-word-limit
              />
            </div>
            <div v-if="qaItem.quesContentTyp === '5'">
              <div class="paragraph">
                <div class="required">
                  <i class="el-icon-right" />
                  必填
                </div>
                <!-- {{ qaItem.quesNm }} -->
                <div v-html="qaItem.quesNm"></div>
              </div>
              <div class="btnBox1">
                <div v-for="item in qaItem.answ" :key="item.answId" class="btn1" :class="{'select': qaItem.value === item.answId}" @click="confirmedFun(item, qaIndex, 1)">{{ item.answVal }}</div>
                <!-- <div class="btn1" :class="{'select': qaItem.value === 2}" @click="confirmedFun(2, qaIndex)">no</div> -->
              </div>
            </div>
            <div v-if="qaItem.quesContentTyp === '6'">
              <div class="paragraph">
                <div class="required">
                  <i class="el-icon-right" />
                  必填
                </div>
                <!-- {{ qaItem.quesNm }} -->
                <div v-html="qaItem.quesNm"></div>
              </div>
              <div class="btnBox1">
                <div class="btn1" :class="{'select': qaItem.value === 1}" @click="confirmedFun(item, qaIndex, 2, 1)">YES</div>
                <div class="btn1" :class="{'select': qaItem.value === 2}" @click="confirmedFun(item, qaIndex, 2, 2)">NO</div>
              </div>
              <div class="contact" v-if="qaItem.value === 1 && qaItem.answ && qaItem.answ.length">
                <div class="tit">请留下您的联系方式</div>
                <div class="inputBox mt20" v-for="item in qaItem.answ" :key="item.answId">
                  <div class="lable">{{ item.answVal }}</div>
                  <el-input v-if="item.answVal.includes('电话') || item.answVal.includes('手机')" placeholder="请输入内容" oninput="if(value.length>5)value=value.slice(0,11)" onkeyup="value=value.replace(/[^\d]/g,'')" v-model="item.answText">
                  </el-input>
                  <el-input v-else placeholder="请输入内容" v-model="item.answText" @input="e => item.answText = removeHTMLTag(e)">
                  </el-input>
                </div>
                <!-- <div class="inputBox mt20">
                  <div class="lable">电话</div>
                  <el-input placeholder="请输入内容" v-model="input1">
                  </el-input>
                </div> -->
              </div>
            </div>
          </template>
        </div>
        <div v-if="page >= Math.ceil(questionnaireData.length / pageSize)" class="hint2">
          <template v-if="isHK || isIIHK">
            請務必按<span>"提交"</span>按鈕 <br>
            以完成調查。
          </template>
          <template v-else>
            请务必按<span>"提交"</span>按钮 <br>
            以完成调查。
          </template>
        </div>
        <div class="btnBox">
          <el-button
            v-if="page !== 1"
            class="btn2"
            type="primary"
            @click="previousPage"
          >{{isHK || isIIHK?'上一頁':'上一页'}}</el-button>
          <el-button
            v-if="page < Math.ceil(questionnaireData.length / pageSize)"
            class="btn2"
            type="primary"
            @click="nextPage"
          >{{isHK || isIIHK?'下一頁':'下一页'}}</el-button>
          <el-button
            v-else
            class="btn2"
            type="primary"
            @click="sub"
          >提交</el-button>
        </div>
      </template>
      <div v-if="answerState && questionnaireData.length === 0" class="grateful">
        暂无问卷
      </div>
      <div v-if="!answerState" class="grateful" v-html="text">
       
      </div>
    </div>
  </div>
</template>
<script>
// import { getCookie, setCookie } from '@/util/auth'
import { saveAnsw, getSurvey } from '@/api/index'
// import MobileDetect from 'mobile-detect'

export default {
  name: 'chat',
  data() {
    return {
      isAgree: false,
      page: 1,
      pageSize:2,
      questionnaireData: [],
      quesId:'',
      chatId:'',
      sign:'',
      answerState: true,
      text:'',
      savequery:{},
      loading: false,
      isHK: false,
      isMainland: false,
      isIIHK: false,
    }
  },
  watch: {
    // 'form.val2': {
    //   deep: true,
    //   handler: function(newV, oldV) {
    //     console.log('watch中：', newV)
    //     this.form.val4 = ''
    //     this.form.val4Text = ''
    //   }
    // }
  },
  mounted() {
    // console.log(this.questionnaireData)
    if (this.$route.query.quesId) {
      this.quesId = decodeURIComponent(this.$route.query.quesId)
    }
    if (this.$route.query.sam) {
      this.chatId = decodeURIComponent(this.$route.query.sam)
    }
    if (this.$route.query.sign) {
      this.sign = decodeURIComponent(this.$route.query.sign)
    }
    if (this.$route.query.callid) {
      this.chatId = decodeURIComponent(this.$route.query.callid)
      this.quesId = 'call'
      this.sign = this.chatId
    }
    if (this.$route.query.r) {
      this.chatId = decodeURIComponent(this.$route.query.r)
      this.quesId = 'call'
      this.sign = this.chatId
    }
    // console.log(this.quesId,this.sam,this.sign)
    let deviceMarketNm = ''
    console.log(window.env)
    if (window.env === 'app') {
      deviceMarketNm = window.interConnection.getDeviceModel()
    } else {
      deviceMarketNm = this.userAgent().osName
    }
    this.savequery = {
      surveyDevice:	'', // 设备元数据；Survey Device
      mobileDeviceBrand:	this.userAgent().osName, // 设备元数据；Mobile Device Brand；手机设备品牌名称
      deviceModel:	this.userAgent().osVersion, // 设备元数据；Device Model（设备型号）
      deviceMarketNm:	deviceMarketNm, // 设备元数据；Device Marketing Name（设备的市场名称）
      screenResolution:	this.$route.query.sourceType ? '' : window.parent.innerWidth + '*' + window.parent.innerHeight, // 网页收集信息；Screen Resolution（分辨率，例如：320 *480）
      browser:	this.userAgent().browserName, // 设备元数据；Browser（浏览器）
      browserVer:	this.userAgent().browserVersion, // 设备元数据；Browser Version（浏览器的版本号）
      operSys:	this.userAgent().osName, // 设备元数据；Operating System（操作系统）
      osVer:	this.userAgent().osVersion, // 设备元数据;OS Version（操作系统的型号）
    }
    // console.log(this.savequery)
    this.getQues()
    
  },
  methods: {
    removeHTMLTag(str) {
            str = str.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/%/g, '').replace(/%00/g, '');
            str = str.replace(/<\/?[^>]*>/g,''); //去除HTML tag
            str = str.replace(/[ | ]*\n/g,'\n'); //去除行尾空白
            //str = str.replace(/\n[\s| | ]*\r/g,'\n'); //去除多余空行
            // str=str.replace(/ /ig,'');//去掉 
            // str = str.trim()
            str = str.replace(/<.+?>/g,"")
            return str;
    },
    showElementsByPage(i, page, elementsPerPage) {
      const pageIndexStart = (page - 1) * elementsPerPage;
      const pageIndexEnd = page * elementsPerPage;
      if (i >= pageIndexStart && i < pageIndexEnd) {
        return true
      }
    },
    nextPage() {
      if (this.page < Math.ceil(this.questionnaireData.length / this.pageSize)) {
        if (this.qaCheck()) {
          this.page++
        }
      }
    },
    previousPage() {
      if (this.page > 1) {
        this.page--
      }
    },
    confirmedFun(val, index, type, val1) {
      if (type === 1) {
        this.questionnaireData[index].value = val.answId
      }
      if (type === 2) {
        this.questionnaireData[index].value = val1
        // if (val.subAnsw && val.subAnsw.length) {
        //   let data = val.subAnsw.map(item => {
        //     item.answText = ''
        //     return item
        //   })
        //   this.questionnaireData[index].subAnsw = JSON.parse(JSON.stringify(data))
        // } else {
        //   this.questionnaireData[index].subAnsw = null
        // }
      }
      
    },
    qaCheck() {
      debugger
      // const pageIndexStart = (this.page - 1) * this.pageSize;
      const pageIndexEnd = this.page * this.pageSize;
      // console.log('aaa',this.page , this.pageSize,pageIndexEnd,pageIndexEnd-1,this.questionnaireData.length)
      let pageSize = 0
      if ((pageIndexEnd) >= this.questionnaireData.length) {
        pageSize = this.pageSize - (pageIndexEnd - this.questionnaireData.length)
      } else {
        pageSize = this.pageSize
      }
      console.log('pageIndexEnd',pageIndexEnd)
      console.log('pageSize',pageSize)
      console.log('this.questionnaireData.length',this.questionnaireData.length)
      if (pageSize > 1) {
        for (let i = pageSize - 1; i >= 0; i--){
        // for (let i = 0 ; i < pageSize; i++){
          console.log('aaaaa',pageIndexEnd - (i + 1),pageSize,i)
          console.log('nnnnnn',this.questionnaireData[pageIndexEnd - (i + 1)])
          let questionnaireData = this.questionnaireData[pageIndexEnd - (i + 1)]
          if ((questionnaireData.quesContentTyp === '2') && questionnaireData.value === '') {
            this.$message({
              message: '请您回答当前必填问题',
              type: 'warning'
            });
            return false
          }
          if ((questionnaireData.quesContentTyp === '7') && questionnaireData.value === '') {
            this.$message({
              message: '请您回答当前必填问题',
              type: 'warning'
            });
            return false
          }
          if (questionnaireData.quesContentTyp === '5') {
            // console.log(11,questionnaireData)
            if (questionnaireData.value === '') {
              this.$message({
                message: '请您回答当前必填问题',
                type: 'warning'
              });
              return false
            }
            // if (questionnaireData.subAnsw && questionnaireData.subAnsw.length) {
            //   for (let i=0;i<questionnaireData.subAnsw.length;i++){
            //     if (!questionnaireData.subAnsw[i].answText) {
            //       this.$message({
            //         message: '请您填写' + questionnaireData.subAnsw[i].answVal,
            //         type: 'warning'
            //       });
            //       return false
            //     } else {
            //       if (questionnaireData.subAnsw[i].answVal.includes('电话') || questionnaireData.subAnsw[i].answVal.includes('手机')) {
            //         let reg = /^1[23456789][0-9]{9}$/;
            //         if (!reg.test(questionnaireData.subAnsw[i].answText)) {
            //           this.$message({
            //             message: '手机号码格式不正确',
            //             type: 'warning'
            //           });
            //         }
            //       }
            //     }
            //   }
            // } else if (questionnaireData.value === '') {
            //   this.$message({
            //     message: '请您回答当前必填问题',
            //     type: 'warning'
            //   });
            //   return false
            // }
          }
          if (questionnaireData.quesContentTyp === '6') {
            if (!questionnaireData.value) {
              this.$message({
                message: '请您回答当前必填问题',
                type: 'warning'
              });
              return false
            } else {
              if (questionnaireData.answ && questionnaireData.answ.length) {
                if (questionnaireData.value === 1) {
                  for (let i=0;i<questionnaireData.answ.length;i++){
                    if (!questionnaireData.answ[i].answText) {
                      this.$message({
                        message: '请您填写' + questionnaireData.answ[i].answVal,
                        type: 'warning'
                      });
                      return false
                    } else {
                      if (questionnaireData.answ[i].answVal.includes('电话') || questionnaireData.answ[i].answVal.includes('手机')) {
                        let reg = /^1[23456789][0-9]{9}$/;
                        if (!reg.test(questionnaireData.answ[i].answText)) {
                          this.$message({
                            message: '手机号码格式不正确',
                            type: 'warning'
                          });
                          return false
                        }
                      }
                    }
                  }
                }
                
              }
            }
          }
          if (questionnaireData.quesContentTyp === '1') {
            for (let i = 0;i < questionnaireData.list.length;i++) {
              if (questionnaireData.list[i].value === '') {
                  this.$message({
                    message: '请您回答当前必填问题',
                    type: 'warning'
                  });
                  return false
              }
            }
            // if (questionnaireData.list && questionnaireData.list.length) {
            //   for (let i = 0;i < questionnaireData.list.length;i++) {
            //     if (questionnaireData.list[i].value === '') {
            //         this.$message({
            //           message: '请您回答当前必填问题',
            //           type: 'warning'
            //         });
            //         return false
            //     }
            //   }
            // } else if (questionnaireData.value === '') {
            //   this.$message({
            //     message: '请您回答当前必填问题',
            //     type: 'warning'
            //   });
            //   return false
            // }
            
          }
        }
      } else {
        console.log(':::::::::',this.questionnaireData[pageIndexEnd - (pageSize + 1)])
        console.log(':::::::::',JSON.stringify(this.questionnaireData[pageIndexEnd - (pageSize + 1)]))
        let questionnaireData = JSON.parse(JSON.stringify(this.questionnaireData[pageIndexEnd - (pageSize + 1)]))
          if ((questionnaireData.quesContentTyp === '2') && questionnaireData.value === '') {
            this.$message({
              message: '请您回答当前必填问题',
              type: 'warning'
            });
            return false
          }
          if ((questionnaireData.quesContentTyp === '7') && questionnaireData.value === '') {
            this.$message({
              message: '请您回答当前必填问题',
              type: 'warning'
            });
            return false
          }
          if (questionnaireData.quesContentTyp === '5') {
            // console.log(11,questionnaireData)
            if (questionnaireData.value === '') {
              this.$message({
                message: '请您回答当前必填问题',
                type: 'warning'
              });
              return false
            }
            // if (questionnaireData.subAnsw && questionnaireData.subAnsw.length) {
            //   for (let i=0;i<questionnaireData.subAnsw.length;i++){
            //     if (!questionnaireData.subAnsw[i].answText) {
            //       this.$message({
            //         message: '请您填写' + questionnaireData.subAnsw[i].answVal,
            //         type: 'warning'
            //       });
            //       return false
            //     } else {
            //       if (questionnaireData.subAnsw[i].answVal.includes('电话') || questionnaireData.subAnsw[i].answVal.includes('手机')) {
            //         let reg = /^1[23456789][0-9]{9}$/;
            //         if (!reg.test(questionnaireData.subAnsw[i].answText)) {
            //           this.$message({
            //             message: '手机号码格式不正确',
            //             type: 'warning'
            //           });
            //         }
            //       }
            //     }
            //   }
            // } else if (questionnaireData.value === '') {
            //   this.$message({
            //     message: '请您回答当前必填问题',
            //     type: 'warning'
            //   });
            //   return false
            // }
          }
          if (questionnaireData.quesContentTyp === '6') {
            if (!questionnaireData.value) {
              this.$message({
                message: '请您回答当前必填问题',
                type: 'warning'
              });
              return false
            } else {
              if (questionnaireData.answ && questionnaireData.answ.length) {
                if (questionnaireData.value === 1) {
                  for (let i=0;i<questionnaireData.answ.length;i++){
                    if (!questionnaireData.answ[i].answText) {
                      this.$message({
                        message: '请您填写' + questionnaireData.answ[i].answVal,
                        type: 'warning'
                      });
                      return false
                    } else {
                      if (questionnaireData.answ[i].answVal.includes('电话') || questionnaireData.answ[i].answVal.includes('手机')) {
                        let reg = /^1[23456789][0-9]{9}$/;
                        if (!reg.test(questionnaireData.answ[i].answText)) {
                          this.$message({
                            message: '手机号码格式不正确',
                            type: 'warning'
                          });
                          return false
                        }
                      }
                    }
                  }
                }
                
              }
            }
          }
          if (questionnaireData.quesContentTyp === '1') {
            for (let i = 0;i < questionnaireData.list.length;i++) {
              if (questionnaireData.list[i].value === '') {
                  this.$message({
                    message: '请您回答当前必填问题',
                    type: 'warning'
                  });
                  return false
              }
            }
            // if (questionnaireData.list && questionnaireData.list.length) {
            //   for (let i = 0;i < questionnaireData.list.length;i++) {
            //     if (questionnaireData.list[i].value === '') {
            //         this.$message({
            //           message: '请您回答当前必填问题',
            //           type: 'warning'
            //         });
            //         return false
            //     }
            //   }
            // } else if (questionnaireData.value === '') {
            //   this.$message({
            //     message: '请您回答当前必填问题',
            //     type: 'warning'
            //   });
            //   return false
            // }
            
          }
      }
      
      return true
    },
    async sub() {
      if (this.qaCheck()) {
        let data = {
          ...this.savequery,
          pageUrl:window.location.href,
          "survCd":this.quesId,
          "chatId":this.chatId,
          "sign":this.sign,
          "ques": []
        }
        this.questionnaireData.forEach(item => {
          if (item.quesContentTyp === '2' || item.quesContentTyp === '7') {
            data.ques.push({
                'quesId':item.quesId,
                'answ':[
                  {'answId':item.value}
                ]
            })
          }
          if (item.quesContentTyp === '3') {
            data.ques.push({
                'quesId':item.quesId,
                'answ':[
                  {
                    'answId':item.answ[0].answId,
                    'answText': item.value ? item.value : '未填写'
                  }
                ]
            })
          }
          if (item.quesContentTyp === '1') {
            // let answ = []
            item.list.forEach(item4 => {
              // answ.push({
              //   'answId':item4.value
              // })
              // answ = [{
              //   'answId':item4.value
              // }]
              data.ques.push({
                'quesId':item4.quesId,
                'answ':[{
                  'answId':item4.value,
                }]
              })
            })
            // data.ques.push({
            //     'quesId':item.quesId,
            //     'answ':answ
            // })
          }
          if (item.quesContentTyp === '5') {
            data.ques.push({
              'quesId':item.quesId,
              'answ':[
                {
                  'answId':item.value,
                }
              ]
            })
          }
          if (item.quesContentTyp === '6') {
            if (item.value === 1) {


              if (item.answ && item.answ.length) {
                let answ = []
                item.answ.forEach(item5 => {
                  answ.push({
                    'answId':item5.answId,
                    'answText':item5.answText
                  })
                })
                data.ques.push({
                  'quesId':item.quesId,
                  'answ':answ
                })
              }
            }
            if (item.value === 2) {
              if (item.answ && item.answ.length) {
                let answ = []
                item.answ.forEach(item5 => {
                  answ.push({
                    'answId':item5.answId,
                    'answText':'未填写'
                  })
                })
                data.ques.push({
                  'quesId':item.quesId,
                  'answ':answ
                })
              }
            }
            // if (item.subAnsw && item.subAnsw.length) {
            //   let answ = []
            //   item.subAnsw.forEach(item5 => {
            //     answ.push({
            //       'answId':item5.answId,
            //       'answText':item5.answText
            //     })
            //   })
            //   data.ques.push({
            //     'quesId':item.quesId,
            //     'answ':answ
            //   })
            // } else {
            //   data.ques.push({
            //     'quesId':item.quesId,
            //     'answ':[
            //       {
            //         'answId':item.value,
            //       }
            //     ]
            //   })
            // }
            
          }
        })
        console.log(data)
        this.loading = true
        const res = await saveAnsw(data)
        this.loading = false
        if (res.code === 'ok') {
          this.$message({
            message: '提交成功',
            type: 'success'
          });
          this.text = '问卷已提交'
          if (this.isHK) {
            this.text = '問卷已提交，感謝閣下的寶貴意見 !<br>Your survey has been submitted. Thank you for your valuable feedback!'
          }
          if(this.isIIHK) {
            this.text = '你的意見有助我們不斷改進和提升服務，感謝你的參與和支持 !<br>Your feedback helps us continuously improve and enhance our services. Thank you for your participation and support!'
          }
          this.answerState = false
        }
      }
    },
    // consentToTheSurvey() {
    //   if (this.isAgree) {
    //     this.page++
    //     this.submitData.agree = '1'
    //   } else {
    //     this.$message.error('请阅读并同意隐私政策。')
    //   }
    // },
    recursion(data, arr, param) {
      const _this = this
      let newData = arr || []
      data.forEach(item => {
        newData.push(item)
        if (item[param] && item[param].length) {
          _this.recursion(item[param], newData, param)
        }
      })
      return newData
    },
    radioChange(e, index, item, indexC) {
      // console.log('qqqqqqqqqqqq',e, index, item, indexC)
      if (item.subQues && item.subQues.length) {
        console.log((this.questionnaireData[index].list.length - 1) , indexC, this.questionnaireData[index].list[indexC])
        if ((this.questionnaireData[index].list.length - 1) === indexC) {
          let problem = item.subQues[0]
          problem.value = ''
          this.questionnaireData[index].list.push(problem)
        } else {
          if (item.subQues && item.subQues.length) {
            this.questionnaireData[index].list.splice(indexC + 1, this.questionnaireData[index].list.length - indexC)
            let problem = item.subQues[0]
            problem.value = ''
            this.questionnaireData[index].list.push(problem)
          } else {
            this.questionnaireData[index].list.splice(indexC + 1, this.questionnaireData[index].list.length - indexC)
          }
        }
        
      } else {
        this.questionnaireData[index].list.splice(indexC + 1, this.questionnaireData[index].list.length - indexC)
      }
    },
    checkedRate(val, index) {
      console.log(val, index,'vale index')
      this.questionnaireData[index].value = val.answId
      
      if (val.subQues && val.subQues.length) {
        val.subQues.forEach((item) => {
          const qaI = this.questionnaireData.findIndex((qa) => {return item.quesId === qa.quesId})
          console.log(qaI)
          if (qaI === -1) {
            item.value = ''
            this.questionnaireData.push(item)
          }
        })
      } else {
        const qaI = this.questionnaireData.findIndex((qa) => {return qa.quesParId === this.questionnaireData[index].quesId})
        console.log(qaI)
        if (qaI != -1) {
          this.questionnaireData.splice(qaI, 1)
        }
      }
    },
    async getQues() {
      const data = {
        "survCd":this.quesId,
        "chatId":this.chatId,
        "sign":this.sign
      }
      this.loading = true
      const res = await getSurvey(data)
      this.loading = false
      console.log('data', res)
      if (res.code === 'ok' && res.data && res.data.ques && res.data.ques.length) {
        this.questionnaireData = res.data.ques.map((item,index) => {
          let problem = item
          problem.value = ''
          if (problem.quesContentTyp === '1') {
            // problem.value = []
            console.log(problem)
            problem.list = [JSON.parse(JSON.stringify(problem))]
          }
          return problem
        })
       
        console.log('data', this.questionnaireData)
        if (res.data.survCd === 'CIHK' || res.data.survCd === 'IHHK' || res.data.survCd === 'PSHK') {
          this.isHK = true
        }
        if (res.data.survCd === 'CI' || res.data.survCd === 'IH' || res.data.survCd === 'PS') {
          this.isMainland = true
        }
        if (res.data.survCd === 'IIHK') {
          this.isIIHK = true
        }
      }
      if (res.code === 'E_SUBMIT_COMPLETE') {
        this.text = '抱歉！您已填写过此问卷，请勿重复填写！'
        // if (this.isHK) {
        //     this.text = '閣下已填寫此問卷，感謝您的寶貴意見 !<br>You have already completed this survey. Thank you for your valuable feedback!'
        //   }
        this.answerState = false
      }
      if (res.code === 'E_SUR_NULL') {
        this.text = '问卷不存在'
        this.answerState = false
      }
      if (res.code === 'E_EXP_DT') {
        this.text = '抱歉！链接已过有效期，期待您的下次参与。'
        // if (this.isHK) {
        //     this.text = '抱歉！此連結已失效，期待閣下下次參與<br>This link has expired, and we look forward to your next participation'
        //   }
        this.answerState = false
      }
    },
    userAgent() {
      const browserReg = {
        Chrome: /Chrome/,
        IE: /MSIE/,
        Firefox: /Firefox/,
        Opera: /Presto/,
        Safari: /Version\/([\d.]+).*Safari/,
        '360': /360SE/,
        QQBrowswe: /QQ/,
        Edge: /Edg/
      }
      const deviceReg = {
        iPhone: /iPhone/,
        iPad: /iPad/,
        Android: /Android/,
        Windows: /Windows/,
        Mac: /Macintosh/
      }
      const userAgentStr = navigator.userAgent
      const userAgentObj = {
        browserName: '', // 浏览器名称
        browserVersion: '', // 浏览器版本
        osName: '', // 操作系统名称
        osVersion: '', // 操作系统版本
        deviceName: '' // 设备名称
      }
      for (const key in browserReg) {
        if (browserReg[key].test(userAgentStr)) {
          userAgentObj.browserName = key
          if (key === 'Chrome') {
            userAgentObj.browserVersion = userAgentStr.split('Chrome/').length >= 2 ? userAgentStr.split('Chrome/')[1].split(' ')[0] : ''
          } else if (key === 'IE') {
            userAgentObj.browserVersion = userAgentStr.split('MSIE ').length >= 2 ? userAgentStr.split('MSIE ')[1].split(' ')[1] : ''
          } else if (key === 'Firefox') {
            userAgentObj.browserVersion = userAgentStr.split('Firefox/').length >= 2 ? userAgentStr.split('Firefox/')[1] : ''
          } else if (key === 'Opera') {
            userAgentObj.browserVersion = userAgentStr.split('Version/').length >= 2 ? userAgentStr.split('Version/')[1] : ''
          } else if (key === 'Safari') {
            userAgentObj.browserVersion = userAgentStr.split('Version/').length >= 2 ? userAgentStr.split('Version/')[1].split(' ')[0] : ''
          } else if (key === '360') {
            userAgentObj.browserVersion = ''
          } else if (key === 'QQBrowswe') {
            userAgentObj.browserVersion = userAgentStr.split('Version/').length >= 2 ? userAgentStr.split('Version/')[1].split(' ')[0] : ''
          } else if (key === 'Edge') {
            userAgentObj.browserVersion = userAgentStr.split('Edg/').length >= 2 ? userAgentStr.split('Edg/')[1].split(' ')[0] : ''
          }
        }
      }

      for (const key in deviceReg) {
        if (deviceReg[key].test(userAgentStr)) {
          userAgentObj.osName = key
          if (key === 'Windows') {
            userAgentObj.osVersion = userAgentStr.split('Windows NT ').length >= 2 ? userAgentStr.split('Windows NT ')[1].split(';')[0] : ''
          } else if (key === 'Mac') {
            userAgentObj.osVersion = userAgentStr.split('Mac OS X ').length >= 2 ? userAgentStr.split('Mac OS X ')[1].split(')')[0] : ''
          } else if (key === 'iPhone') {
            userAgentObj.osVersion = userAgentStr.split('iPhone OS ').length >= 2 ? userAgentStr.split('iPhone OS ')[1].split(' ')[0] : ''
          } else if (key === 'iPad') {
            userAgentObj.osVersion = userAgentStr.split('iPad; CPU OS ').length >= 2 ? userAgentStr.split('iPad; CPU OS ')[1].split(' ')[0] : ''
          } else if (key === 'Android') {
            userAgentObj.osVersion = userAgentStr.split('Android ').length >= 2 ? userAgentStr.split('Android ')[1].split(';')[0] : ''
            userAgentObj.deviceName = userAgentStr.split('(Linux; Android ').length >= 2 ? userAgentStr.split('(Linux; Android ')[1].split('; ')[1].split(' Build')[0] : ''
          }
        }
      }
      return userAgentObj
    }
  }
}
</script>
<style scoped lang="scss">
@function Vw($px) {
	@return $px / 750px * 100vw
  }
.pBox{
  min-height: 100vh;
}
.feedbackSurvey {
  margin: 0 auto;
  max-width: 768px;
  min-width: 230px;
  padding: 32px 24px;
  .statement{
    font-size: 14px;
    color: #5c5c5c;
  }
  .mt40 {
    margin-top: 40px;
  }
  .mt20 {
    margin-top: 20px;
  }
  .required {
    opacity: 0.5;
    font-size: 16px;
    margin-bottom: 8px;
  }
  .paragraph {
    position: relative;
    margin: 32px 0;
    font-size: (28px);
    line-height: 38px;
    width: 100%;
    color: #213144;
    a {
      color: #1b6ec2;
      text-decoration: underline;
    }
    .focus{
      font-weight: 600;
      text-decoration:underline;
    }
  }
  .hint2{
    margin-top: 50px;
    text-align: center;
    span{
      font-weight: 600;
    }
  }
  .isAgree {
    margin-top: 24px;
  }
  .agreeBtn {
    padding: 32px 0;
    text-align: center;
    .el-button {
      width: 50%;
      font-size: 20px;
      padding: 16px 0;
    }
  }
  .support {
    text-align: center;
    p {
      line-height: 35px;
      span {
        letter-spacing: 1px;
      }
      span:nth-child(1) {
        font-size: 14px;
        opacity: 0.6;
      }
      span:nth-child(2) {
        font-size: 20px;
        font-weight: 600;
      }
      a {
        font-size: 12px;
        color: #213144;
        text-decoration: underline;
      }
    }
  }
  .hint {
    width: 100%;
    margin-bottom: 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .group_group {
    border: 1px solid #dae0ea;
    box-shadow: 0 1px 3px 0 rgba(217, 217, 217, 0.6);
    .group_optionContainer {
      border-bottom: 1px solid #dae0ea;
      // padding: 16px;
    }
    .group_optionContainer:hover {
      border: 1px solid #1890ff;
    }
    .group_optionContainer:last-child {
      border-bottom: none;
    }
    .group_optionContainer:last-child:hover {
      border: 1px solid #1890ff;
    }
  }
  .btnBox {
    width: 50%;
    margin-top: 50px;
    margin-left: 25%;
    display: flex;
    flex-direction: row;
    // justify-content: space-between;
    justify-content: center;
    .btn1,
    .btn2 {
      width: 47%;
      font-size: 18px;
      text-align: center;
      padding: 16px 0;
    }
    .btn1 {
      background-color: #e2e2e2;
      color: rgb(36, 35, 35);
    }
    .btn2 {
      background-color: #1890ff;
    }
  }
  .btnBox1{
    width: 50%;
    margin-top: 30px;
    display: flex;
    flex-direction: row;
    // justify-content: space-between;
    .btn1,.btn2{
      width: 120px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      border: 1px solid #bbbaba;
      border-radius: 8px;
      margin-right: 20px;
      cursor: pointer;
    }
    .select{
      background-color: #1890ff;
      border: 1px solid #1890ff;
      color:#fff;
    }
  }
  .contact{
    margin-top: 20px;
    width: 50%;
    border: 1px solid #efefef;
    border-radius: 8px;
    padding: 20px;
    .tit{
      font-size: 18px;
    }
    .inputBox{
      display: flex;
      align-items: center;
      .lable{
        width: 50px;
      }
    }
  }
  .rate2 {
    overflow: hidden;
    height: 60px;
    line-height: 60px;
    .hint1 {
      float: right;
      width: 70%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      font-size: 14px;
    }
    .label {
      width: 30%;
      float: left;
    }
    .rateBox {
      width: 70%;
      float: right;
      height: 60px;
      position: relative;
      display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
      .rateComponents{
        // position: absolute;
        // margin:auto;
        // top: 0;
        //     left: 0;
        //     bottom: 0;
        //     right: 0;
      }
    }
  }
  
  @media screen and (max-width: 600px) {
  .rateComponents{
    width: 100%;
    display: flex;
    flex-direction: row;
    .rateItem:hover{
            border:1px solid #1890ff;
        }
    .rateItem{
        border:1px solid #dae0ea;
        text-align: center;
        line-height: Vw(50px);
        min-width:Vw(50px);
        min-height: Vw(50px);
        font-size: Vw(16px);
        flex:1;
        position: relative;
        cursor: pointer;
        .rateNum{
            width: Vw(40px);
            height:  Vw(40px);
            line-height:  Vw(40px);
            border-radius:  Vw(50px);
            text-align: center;
            position: absolute;
            margin: auto;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
        }
        .rateNum.select{
            background-color: #1890ff;
            color:#fff;

        }
    }
  }
}
  @media screen and (min-width: 600px){
    .rateComponents{
    width: 100%;
    display: flex;
    flex-direction: row;
    .rateItem:hover{
            border:1px solid #1890ff;
        }
    .rateItem{
        border:1px solid #dae0ea;
        text-align: center;
        line-height: 50px;
        min-width:50px;
        min-height: 50px;
        // max-width: 10%;
        // min-width:;
        flex:1;
        position: relative;
        font-size: 16px;
        cursor: pointer;
        .rateNum{
            width: 40px;
            height: 40px;
            text-align: center;
            line-height: 40px;
            border-radius: 50px;
            position: absolute;
            margin: auto;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
        }
        .rateNum.select{
            background-color: #1890ff;
            color:#fff;

        }
    }
  }
  }
//   .rateComponents{
//     width: 100%;
//     display: flex;
//     flex-direction: row;
//     .rateItem:hover{
//             border:1px solid #1890ff;
//         }
//     .rateItem{
//         border:1px solid #dae0ea;
//         text-align: center;
//         line-height: 50px;
//         min-width:50px;
//         min-height: 50px;
//         // max-width: 10%;
//         // min-width:;
//         flex:1;
//         position: relative;
//         font-size: 16px;
//         cursor: pointer;
//         .rateNum{
//             width: 40px;
//             height: 40px;
//             text-align: center;
//             line-height: 40px;
//             border-radius: 50px;
//             position: absolute;
//             margin: auto;
//             top: 0;
//             left: 0;
//             bottom: 0;
//             right: 0;
//         }
//         .rateNum.select{
//             background-color: #1890ff;
//             color:#fff;

//         }
//     }
//   }
  .grateful{
    font-size: 18px;
    margin-top: 20px;
    padding-top: 50px;
    border-top:1px solid #bebebe;
  }
}
@media screen and (max-width: 460px) {
  .feedbackSurvey {
    .paragraph{
      font-size: Vw(48px);
      line-height: Vw(58px);
    }
    .btnBox1{
      font-size: Vw(30px);
      .btn1,.btn2{
        width: Vw(180px);
        height: Vw(70px);
        line-height: Vw(70px);
      }
    }
    .btnBox{
      .btn1,.btn2{
        font-size: Vw(30px);
      }
    }
    .contact{
      margin-top: 20px;
      width: 100%;
      border: 1px solid #efefef;
      border-radius: 8px;
      padding: Vw(30px);
      box-sizing: border-box;
      .tit{
        font-size: 18px;
      }
      .inputBox{
        display: flex;
        align-items: center;
        .lable{
          width: 50px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
@function Vw($px) {
	@return $px / 750px * 100vw
  }
.feedbackSurvey .el-checkbox.is-bordered.el-checkbox--medium {
  width: 100%;
  padding: 19px;
  height: 53px;
}
.feedbackSurvey
  .el-checkbox.is-bordered.el-checkbox--medium
  .el-checkbox__label {
  font-size: 20px;
}
.feedbackSurvey .rate1 .el-rate {
  height: 60px;
}
.feedbackSurvey .rate1 .el-rate__item {
  width: 9.7%;
  height: 60px;
}
.feedbackSurvey .rate1 .el-rate__item .el-rate__icon {
  font-size: 35px;
  margin-top: 12.5px;
}
.feedbackSurvey .rate1 .el-rate__text {
  font-size: 20px;
}

.feedbackSurvey .el-radio__label {
  font-size: 18px;
  text-overflow: ellipsis;
  white-space: normal;
  vertical-align: middle;
  display: inline-block;
}
.feedbackSurvey .group_group .el-checkbox {
  padding: 16px;
  width: 100%;
  height: 100%;
  text-overflow: ellipsis;
  white-space: normal;
  vertical-align: middle;
  display: inline-block;
}
.feedbackSurvey .group_group .el-checkbox__label {
  font-size: 18px;
}
.feedbackSurvey .rateBox .el-rate {
  height: 60px;
  line-height: 60px;
}
.feedbackSurvey .rateBox .el-rate__item {
  width: 14.2%;
  height: 60px;
  line-height: 60px;
}
.feedbackSurvey .rateBox .el-rate__item .el-rate__icon {
  font-size: 35px;
  margin-top: 12.5px;
}
.feedbackSurvey .rate3 .el-checkbox__label {
  font-size: 18px;
}
.feedbackSurvey .rate3 .el-rate {
  height: 60px;
  line-height: 60px;
}
.feedbackSurvey .rate3 .el-rate__item {
  width: 14%;
  height: 60px;
  line-height: 60px;
}
.feedbackSurvey .rate3M .el-rate__item {
  width: 13%;
  height: 60px;
  line-height: 60px;
}
.feedbackSurvey .rate3 .el-rate__item .el-rate__icon {
  font-size: 35px;
  margin-top: 12.5px;
}
.feedbackSurvey .rate3 .el-rate__text {
  font-size: 20px;
}
@media screen and (max-width: 460px) {
  .feedbackSurvey .el-radio {
    padding: 16px;
    max-width: 100%;
    min-width: 91%;
    height: 100%;
  }
  .feedbackSurvey .el-radio__label{
    font-size: Vw(33px);
    line-height: Vw(35px);
  }
}
@media screen and (min-width: 461px) {
  .feedbackSurvey .el-radio {
    padding: 16px;
    max-width: 100%;
    min-width: 95%;
    height: 100%;
  }
}
</style>
